import { gql } from '@apollo/client'

export const GET_PROPERTY_AND_DETAILS = gql`
  query getPropertyAndDetails($id: Int!) {
    property(id: $id) {
      id
      name
      full_address
      lat
      long
      status
      is_active
      timezone
      website
      created_at
      updated_at
      pms_id
      admin_fee
      max_daily_late_fees_amount
      brand_color
      brand_logo_url
      state
      city
      zip
      type
      description
      class
      account_integration_properties {
        id
        pms_id
        isActive
        property {
          id
        }
        account_integration {
          metadata
          id
          isActive
          integration {
            id
            description
          }
        }
      }
      property_detail_floorplan {
        id
        title
        url
      }
      property_detail_tour_video {
        id
        title
        description
        url
      }
      property_detail_map {
        id
        title
        description
        url
      }
      property_detail_service {
        id
        name
        website
        phone
      }
      property_detail_gallery {
        id
        url
      }
      property_detail_access {
        id
        title
        description
      }
      property_detail_utility {
        id
        provider_name
        website
        estimate
      }
      property_staff {
        id
        user {
          id
          first_name
          last_name
          phone_number
        }
      }
      property_detail {
        id
        rentable_area
        average_unit_size
        acreage_and_density
        building_count
        landscaping
        parking_spaces
        parking_ratio
        flood_zone
        style
        exterior_walls
        unit_count
        google_map_link
        exterior_doors_and_windows
        foundation
        roof
        ceiling_height
        flood_coverings
        paving
        plumbing
        wiring
        unit_fire_protection
        provider_name
        estimate
        is_housing_accepted
        application_fee
        holding_fee
        deposit
        wheel_chair_accessibilty
      }
      property_phones {
        id
        phone_number
      }
      property_group_properties {
        id
        property_group {
          id
          name
        }
      }
      units {
        id
        name
        status
        unit_number
        unit_type
        bed
        bathroom
        status
        sqft
        market_rent
        rent
        default_deposit
        unit_occupancies {
          id
          account_id
          unit_occupancy_tenants {
            id
            person {
              id
              first_name
              last_name
            }
          }
        }
      }
    }
  }
`

export const GET_PROPERTIES = gql`
  query getProperties {
    properties {
      id
      name
    }
  }
`

export const GET_PERSON = gql`
  query getPersonSidePanel($id: Int!) {
    person(id: $id) {
      id
      birthday
      type
      first_name
      last_name
      unit_occupancy_tenants {
        id
        pms_id
        is_active
        unit_occupancy {
          id
          pms_id
          status
          lease_from
          lease_to
          rent
          deposit
          current_balance
          move_in
          move_out
          is_active
          lease_signed
          last_payment
          last_payment_id
          current_lease
          current_lease_url
          monthly_charges
          is_eviction
          is_collections
          is_cert_funds_only
          allow_online_payment
          require_payment_full
          eligible_renewal
          unit {
            id
            pms_id
            name
            description
            bed
            bathroom
          }
          property {
            id
            pms_id
            name
            street_address
            city
            state
            zip
          }
          unit_occupancy_tenants {
            id
            pms_id
            is_active
            person {
              id
              first_name
              last_name
            }
          }
        }
      }
      person_guest_cards {
        id

        guest_card {
          id
          received_at
          move_in_preference
          max_rent
          bed_bath_preference
          monthly_income
          credit_score
          lead_type
          pms_id
          lead_source {
            id
            name
          }
          unit {
            id
            pms_id
            name
            description
            bed
            bathroom
          }
          property {
            id
            pms_id
            name
            street_address
            city
            state
            zip
          }
        }
      }

      account_integration {
        id
        isActive
        metadata
        integration {
          id
          description
        }
      }
      person_properties {
        id
        property {
          id
          name
        }
      }
      sticky_number {
        id
        phone_number
        property {
          id
          name
        }
      }
      emails {
        id
        is_default
        address
      }
      phones {
        id
        is_default
        phone_number
      }
    }
  }
`
